import MetricDetailHeader from './MetricDetailHeader';

export default MetricDetailHeader;
